import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.28",
      d: "M8.84 2.4 3.366 8.195c-.206.22-.406.653-.446.953l-.247 2.16c-.087.78.473 1.314 1.247 1.18l2.146-.366c.3-.053.72-.274.927-.5l5.473-5.794c.947-1 1.374-2.14-.1-3.533-1.466-1.38-2.58-.893-3.526.107"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.28",
      d: "M7.926 3.367a4.084 4.084 0 0 0 3.633 3.434M2 14.668h12"
    }, null, -1)
  ]))]))
}
export default { render: render }